import React, { useRef, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import config from '../../../config';
import { Form, Input, notification, Row, Col, Button, Modal, Upload, Spin, Select, Card, Space } from 'antd';
import * as userActions from '../../../redux/actions/userActions';
import {
  PictureOutlined,
  EditOutlined,
  FormOutlined,
  SafetyCertificateOutlined,
  FileImageOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import GenFieldArray from '../../../common_functions/GenFieldArray';
import UploadTrigger from '../../../common_functions/UploadTrigger';
import { basicPhotos, setFormData } from '../../../common_functions/basicPhotos';
import {
  confirmationModal,
  formItemLayout,
  handleBackendFormErrors,
  tailFormItemLayout,
  unexpectedError,
  beforeUpload,
  getFile,
} from '../../../common_functions';

const SectionCard = ({ icon, title, description, children }) => (
  <Card
    className="bp-section-card"
    bordered={false}
    title={
      <Space align="start" size={12}>
        <span className="bp-section-icon">{icon}</span>
        <span>
          <div className="bp-section-title">{title}</div>
          {description && <div className="bp-section-desc">{description}</div>}
        </span>
      </Space>
    }
  >
    {children}
  </Card>
);

const UploadField = ({ name, label, hint, onBeforeUpload, onUploadChange, fileList, onPreview }) => (
  <Form.Item name={name} label={label}>
    <Upload
      name="file"
      className="create_object"
      listType="picture"
      accept={config.FileType.imageType.toString()}
      beforeUpload={onBeforeUpload}
      onChange={onUploadChange}
      maxCount={1}
      multiple={false}
      showUploadList={{ showRemoveIcon: false }}
      fileList={fileList}
      onPreview={onPreview}
    >
      <UploadTrigger fileType="imageType" hint={hint} />
    </Upload>
  </Form.Item>
);

const BasicPhoto = props => {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const { section, id } = useParams();
  const [loading, setLoading] = useState(false);
  const [photosData, setPhotosData] = useState(false);
  const [uploadedData, setUploadedData] = useState({
    print_only: [],
    print_only_small: [],
    thumbnail: [],
    print_and_mount_recto: [],
    mount_verso: [],
    signature_recto: [],
    signature_verso: [],
    annotations_recto: [{}],
    stamp_verso: [{}],
    annotations_verso: [{}],
    image_detail: [{}],
    folder_id: null,
  });
  const [multiFile, setMultiFile] = useState({
    annotations_recto: [{}],
    stamp_verso: [{}],
    annotations_verso: [{}],
    image_detail: [{}],
  });
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewTitle, setPreviewTitle] = useState(false);
  const [previewImage, setPreviewImage] = useState(false);
  const [signatureData, setSignatureData] = useState([]);
  const [stampData, setStampData] = useState([]);
  const [filteredStampData, setFilteredStampData] = useState([]);
  const [parentData, setParentData] = useState();
  const [annotationData, setAnnotationData] = useState([]);
  const [handWriting, setHandWriting] = useState([]);
  const handleCancel = () => setPreviewVisible(false);

  let error = [];
  let saveAndNext = '';
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const { data: signData } = await dispatch(
          userActions.getItems('signatures', {
            fields: ['id', 'signature'],
            limit: -1,
          })
        );

        const { data: aData } = await dispatch(
          userActions.getItems('annotation_materials', {
            fields: ['id', 'name'],
            limit: -1,
          })
        );
        const { data: handWritingNotes } = await dispatch(
          userActions.getItems('hand_writing_notes', {
            fields: ['id', 'name'],
            limit: -1,
          })
        );

        setSignatureData(signData);
        setAnnotationData(aData);
        setHandWriting(handWritingNotes);
        //if print exist then get the print data
        if (!!props?.print) {
          let { data } = await dispatch(
            userActions.getItem('print', props.print, {
              fields: [
                'thumbnail.id',
                'thumbnail.filename_download',
                'c_print.acquisition',
                'folderID',
                'print_mount_con.*',
                'basic_photos.*',
                'basic_photos.print_only.id',
                'basic_photos.print_only.filename_download',
                'basic_photos.print_only_small.id',
                'basic_photos.print_only_small.filename_download',
                'basic_photos.print_and_mount_recto.id',
                'basic_photos.print_and_mount_recto.filename_download',
                'basic_photos.mount_verso.id',
                'basic_photos.mount_verso.filename_download',
                'basic_photos.signature_recto.id',
                'basic_photos.signature_recto.filename_download',
                'basic_photos.signature_verso.id',
                'basic_photos.signature_verso.filename_download',
                'basic_photos.annotations_recto.*',
                'basic_photos.annotations_recto.directus_files_id.filename_download',
                'basic_photos.annotations_recto.directus_files_id.id',
                'basic_photos.annotations_verso.*',
                'basic_photos.annotations_verso.directus_files_id.filename_download',
                'basic_photos.annotations_verso.directus_files_id.id',
                'basic_photos.stamp_verso.*',
                'basic_photos.stamp_verso.directus_files_id.filename_download',
                'basic_photos.stamp_verso.directus_files_id.id',
                'basic_photos.image_detail.*',
                'basic_photos.image_detail.directus_files_id.id',
                'basic_photos.image_detail.directus_files_id.filename_download',
                'basic_photos.image_detail.notes',
                'signature',
                'annotation_material',
                'stamp.*',
                'stamp.id',
                'stamp.is_subgroup',
                'stamp.parent_stamp',
                'stamp_subgroup',
              ],
            })
          );
          const sData = await getStamps();
          setStampData(sData);
          setParentData({
            parentfolderID: data.folderID,
            acquisition: data.c_print[0].acquisition,
          });
          formRef?.current?.setFieldsValue({
            signature_recto_text: data?.signature,
            signature_recto_material: data?.annotation_material,
            stamp_verso: [{ stamp: data?.stamp?.id, stamp_subgroup: data?.stamp_subgroup }],
          });
          if (data.basic_photos.length > 0) {
            let basicPhotosData = data.basic_photos[0];
            basicPhotosData = { ...basicPhotosData, thumbnail: data.thumbnail };
            let newBasicPhotosData = await basicPhotos(basicPhotosData, dispatch);

            setUploadedData({
              ...uploadedData,
              ...newBasicPhotosData,
              folder_id: basicPhotosData?.folder_id,
            });
            basicPhotosData = {
              ...basicPhotosData,
              annotations_recto: setFormData(basicPhotosData.annotations_recto),
              annotations_verso: setFormData(basicPhotosData.annotations_verso),
              stamp_verso: setFormData(basicPhotosData.stamp_verso, data?.stamp?.id, data?.stamp_subgroup),
              image_detail: setFormData(basicPhotosData.image_detail),
              signature_recto_text: basicPhotosData?.signature_recto_text ?? data?.signature,
              signature_recto_material: basicPhotosData?.signature_recto_material ?? data?.annotation_material,
            };
            setPhotosData(basicPhotosData);

            formRef?.current?.setFieldsValue(basicPhotosData);
          } else {
            let basicPhotosData = { ...uploadedData, thumbnail: data.thumbnail };
            let newBasicPhotosData = await basicPhotos(basicPhotosData, dispatch);

            setUploadedData({
              ...uploadedData,
              ...newBasicPhotosData,
            });
            formRef.current.setFieldsValue(data);
          }
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    if (props.activeTab === 'basic_photo') {
      fetchData();
    }
  }, [props.activeTab]);

  const showSubgroup = async parentStamp => {
    setLoading(true);
    let data = await getStamps(true, parentStamp);
    setLoading(false);
    return data;
  };

  const getStamps = async (child = false, parentStamp = null) => {
    const { data } = await dispatch(
      userActions.getItems('stamps', {
        fields: ['id', 'stamp_name', 'picture', 'height', 'width', 'city_width'],
        limit: -1,
        filters: parentStamp ? { parent_stamp: { _eq: parentStamp }, is_subgroup: { _eq: true } } : { is_subgroup: { _eq: false } },
      })
    );
    return data;
  };

  const complete = async values => {
    Modal.destroyAll();
    values = { ...values, object_status: 1 };
    await onSave(values);
  };
  const incomplete = async values => {
    Modal.destroyAll();
    values = { ...values, object_status: 0 };
    await onSave(values);
  };
  let onFinish = async (values, action = null) => {
    saveAndNext = '';
    if (!!action) {
      saveAndNext = action;
    }
    await confirmationModal(values, 'Status', 'Is this record complete or incomplete?', 'Incomplete', 'Complete', complete, incomplete);
  };
  let onSave = async values => {
    if (error.length) return false;
    setLoading(true);
    const formData = new FormData();
    // Loop over the properties of the data object
    Object.keys(multiFile).forEach(propertyKey => {
      const propertyValue = multiFile[propertyKey];
      if (Array.isArray(propertyValue)) {
        propertyValue.forEach((item, index) => {
          Object.keys(item).forEach(key => {
            formData.append(key, item[key]);
          });
        });
      }
    });
    values.stamp_verso = values.stamp_verso.map(obj =>
      Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v === undefined ? null : v]))
    );
    values.annotations_recto = values.annotations_recto.map(obj =>
      Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v === undefined ? null : v]))
    );
    values.annotations_verso = values.annotations_verso.map(obj =>
      Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v === undefined ? null : v]))
    );
    values.image_detail = values.image_detail.map(obj =>
      Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v === undefined ? null : v]))
    );

    formData.append('stamp_verso', JSON.stringify(values.stamp_verso));
    formData.append('annotations_verso', JSON.stringify(values.annotations_verso));
    formData.append('annotations_recto', JSON.stringify(values.annotations_recto));
    formData.append('image_detail', JSON.stringify(values.image_detail));
    Object.entries(values).forEach(([key, value]) => {
      if (!!value && !!value.fileList && value.fileList.length > 0) {
        formData.append(key, value.fileList[0].originFileObj);
      }
    });
    formData.append('object_status', values.object_status);
    formData.append('signature_recto_text', values.signature_recto_text);
    formData.append('signature_recto_material', values.signature_recto_material);
    formData.append('signature_verso_text', values.signature_verso_text);
    formData.append('signature_verso_notation', values.signature_verso_notation);
    formData.append('signature_verso_material', values.signature_verso_material);
    // formData.append('image_detail_1', values.image_detail_1);
    // formData.append('detail_description', values.detail_description);

    //save the print mount conditions data
    try {
      setLoading(true);
      const response = await dispatch(userActions.saveFileItem('basic-photos/basic_photos', formData, props?.print, photosData));
      if (response) {
        notification['success']({
          message: 'Basic photos saved successfully!',
          duration: 2,
        });
        if (saveAndNext == '') {
          setTimeout(() => props.history.push('/print-objects', 1500));
        } else if (saveAndNext == 'next') {
          props.onChange('', 'paper_group', 'Paper Group');
        }
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current?.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    props.onChange('', 'mount_condition', 'Mount Characteristics');
  };

  //if validation  is not passed then dont upload the file
  const fileBeforeUpload = (file, fileName, type = 'imageType') => {
    return beforeUpload(file, type, `${parentData.acquisition}.${fileName}`);
  };

  let uploadFile = ({ file, fileList }, fieldName, fileName) => {
    try {
      if (
        fieldName === 'stamp_verso' ||
        fieldName === 'annotations_recto' ||
        fieldName === 'annotations_verso' ||
        fieldName === 'image_detail'
      ) {
        multiFile[fieldName][0][fileName] = fileList[0].originFileObj;
        setMultiFile({ ...multiFile });
        uploadedData[fieldName][0][fileName] = fileList;
      } else {
        uploadedData[fieldName] = fileList;
      }
      setUploadedData({ ...uploadedData });
    } catch (error) {
      console.log(error);
    }
  };

  const handlePreview = async file => {
    setPreviewImage(file?.url ? file.url : file.thumbUrl);
    setPreviewVisible(true);
    setPreviewTitle(file.name);
  };
  // const handleStampSearch = inputValue => {
  //   const filteredData = stampData.filter(el => el.stamp_name.toLowerCase().includes(inputValue.toLowerCase()));
  //   setFilteredStampData(filteredData);
  // };
  const handleSaveAndNext = action => {
    formRef.current.validateFields().then(values => {
      onFinish(values, action);
    });
  };
  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="white-paper basic-photo-page">
          <Form
            ref={formRef}
            layout="vertical"
            {...formItemLayout}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{ layout: tailFormItemLayout }}
            encType="multipart/form-data"
          >
            <SectionCard
              icon={<PictureOutlined />}
              title="Print & Mount Images"
              description="Recto/verso scans of the print and its mount"
            >
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={8}>
                  <UploadField
                    name="print_only"
                    label="Print only"
                    onBeforeUpload={e => fileBeforeUpload(e, 'print.image')}
                    onUploadChange={e => uploadFile(e, 'print_only', 'print.image')}
                    fileList={uploadedData.print_only}
                    onPreview={handlePreview}
                  />
                </Col>
                <Col xs={24} sm={12} lg={8}>
                  <UploadField
                    name="print_and_mount_recto"
                    label="Print and Mount Recto"
                    onBeforeUpload={e => fileBeforeUpload(e, 'pm.recto')}
                    onUploadChange={e => uploadFile(e, 'print_and_mount_recto', 'pm.recto')}
                    fileList={uploadedData.print_and_mount_recto}
                    onPreview={handlePreview}
                  />
                </Col>
                <Col xs={24} sm={12} lg={8}>
                  <UploadField
                    name="mount_verso"
                    label="Mount Verso"
                    onBeforeUpload={e => fileBeforeUpload(e, 'pm.verso')}
                    onUploadChange={e => uploadFile(e, 'mount_verso', 'pm.verso')}
                    fileList={uploadedData.mount_verso}
                    onPreview={handlePreview}
                  />
                </Col>
              </Row>
            </SectionCard>
            <SectionCard icon={<EditOutlined />} title="Signature — Recto" description="Signature captured on the front of the print">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={8}>
                  <UploadField
                    name="signature_recto"
                    label="Signature Recto"
                    onBeforeUpload={e => fileBeforeUpload(e, 'signature.recto')}
                    onUploadChange={e => uploadFile(e, 'signature_recto', 'signature.recto')}
                    fileList={uploadedData.signature_recto}
                    onPreview={handlePreview}
                  />
                </Col>
                <Col xs={24} sm={12} lg={8}>
                  <Form.Item name="signature_recto_text" label="Signature Recto text">
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      placeholder="Select signature text"
                      style={{ textTransform: 'capitalize' }}
                    >
                      {signatureData.map(el => (
                        <Select.Option key={el.id} value={el.id}>
                          {el.signature}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                  <Form.Item name="signature_recto_material" label="Signature Recto Material">
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      placeholder="Select signature text"
                      style={{ textTransform: 'capitalize' }}
                    >
                      {annotationData.map(el => (
                        <Select.Option key={el.id} value={el.id}>
                          {el.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </SectionCard>

            <SectionCard icon={<EditOutlined />} title="Signature — Verso" description="Signature captured on the back of the print">
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} lg={8}>
                  <UploadField
                    name="signature_verso"
                    label="Signature Verso"
                    onBeforeUpload={e => fileBeforeUpload(e, 'signature.verso')}
                    onUploadChange={e => uploadFile(e, 'signature_verso', 'signature.verso')}
                    fileList={uploadedData.signature_verso}
                    onPreview={handlePreview}
                  />
                </Col>
                <Col xs={24} sm={12} lg={8}>
                  <Form.Item name="signature_verso_text" label="Signature Verso Text">
                    <Select showSearch allowClear filterOption={false} placeholder="Select Signature Verso">
                      {signatureData.map(el => (
                        <Select.Option key={el.id} value={el.id}>
                          {el.signature}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                  <Form.Item name="signature_verso_notation" label="Signature Verso Notation">
                    <Input />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} lg={8}>
                  <Form.Item name="signature_verso_material" label="Signature Verso Material">
                    <Select
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      placeholder="Select Signature Verso Material"
                      style={{ textTransform: 'capitalize' }}
                    >
                      {annotationData.map(el => (
                        <Select.Option key={el.id} value={el.id}>
                          {el.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </SectionCard>
            <SectionCard icon={<FormOutlined />} title="Annotations — Recto" description="Notes and markings found on the front">
              <GenFieldArray
                permissions={{
                  role: props.roleType,
                  tabs_permission: props.deletePermissions,
                }}
                fieldName="annotations_recto"
                uploadFile={uploadFile}
                handlePreview={handlePreview}
                buttonText="Add Annotations Recto"
                label="Annotations Note"
                fileData={uploadedData.annotations_recto}
                extraFields={{ annotation_recto_material: annotationData, annotation_recto_handwriting: handWriting }}
              />
            </SectionCard>

            <SectionCard icon={<FormOutlined />} title="Annotations — Verso" description="Notes and markings found on the back">
              <GenFieldArray
                permissions={{
                  role: props.roleType,
                  tabs_permission: props.deletePermissions,
                }}
                fieldName="annotations_verso"
                uploadFile={uploadFile}
                handlePreview={handlePreview}
                buttonText="Add Annotations Verso"
                label="Annotations Verso Note"
                fileData={uploadedData.annotations_verso}
                extraFields={{ annotation_verso_material: annotationData, annotation_verso_handwriting: handWriting }}
              />
            </SectionCard>

            <SectionCard icon={<SafetyCertificateOutlined />} title="Stamps — Verso" description="Stamps and provenance marks on the back">
              <GenFieldArray
                permissions={{
                  role: props.roleType,
                  tabs_permission: props.deletePermissions,
                }}
                fieldName="stamp_verso"
                uploadFile={uploadFile}
                handlePreview={handlePreview}
                buttonText=" Add Stamp Verso"
                label="Stamp Verso Notation"
                extraFields={{
                  stamp_verso_type: stampData,
                  stamp_verso_notation_material: annotationData,
                  stamp_verso_handwriting: handWriting,
                  // childStamps: childStamps,
                }}
                fileData={uploadedData.stamp_verso}
                // onSearch={handleStampSearch}
                fetchSubStamps={showSubgroup}
                form={formRef.current}
                initialValues={photosData}
              />
            </SectionCard>

            <SectionCard icon={<FileImageOutlined />} title="Image Detail" description="Close-up detail shots with descriptions">
              <GenFieldArray
                permissions={{
                  role: props.roleType,
                  tabs_permission: props.deletePermissions,
                }}
                fieldName="image_detail"
                uploadFile={uploadFile}
                handlePreview={handlePreview}
                buttonText="Add Image Detail"
                label="Image Detail Description"
                extraFields={false}
                fileData={uploadedData.image_detail}
              />
            </SectionCard>

            <Modal
              open={previewVisible}
              title={previewTitle}
              footer={null}
              onCancel={handleCancel}
              className="bp-preview-modal"
              centered
            >
              <div style={{ textAlign: 'center' }}>
                <img
                  alt="example"
                  style={{
                    width: '100%',
                    height: 'auto',
                    textAlign: 'center',
                  }}
                  src={previewImage}
                />
              </div>
            </Modal>
            <Form.Item {...tailFormItemLayout} style={{ marginBottom: 0 }}>
              <div className="bp-footer-bar">
                <div className="bp-footer-actions">
                  <Button
                    type="default"
                    htmlType="button"
                    icon={<ArrowLeftOutlined />}
                    onClick={backButton}
                    style={{
                      borderColor: '#d9d9d9',
                      background: '#f5f5f5',
                      color: 'rgba(0, 0, 0, 0.85)',
                    }}
                  >
                    Back
                  </Button>
                  {props.showButton()}
                  {props.showButton() != '' ? (
                    <Button className="save-btn" type="primary" onClick={() => handleSaveAndNext('next')}>
                      Save and Next
                    </Button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Spin>
  );
};
export default BasicPhoto;
